import React, {useRef, useEffect} from "react";
import {Button, Modal} from 'antd';
import {FormattedMessage, useIntl} from 'react-intl';
import "plyr-react/plyr.css";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const VdocipherComponent = ({video, endVideoSession, endLoading, finish}: any) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const playerRef = useRef<any>(null)
    const intl = useIntl();
    const {confirm} = Modal;

    useEffect(() => {
        const handleEnded = () => endVideoSession(true);

        const attachPlayer = () => {
            // @ts-ignore
            const player = window.VdoPlayer?.getInstance(iframeRef.current);
            if (!player?.video) {
                return;
            }
            playerRef.current = player;
            player.video.addEventListener("ended", handleEnded);
        };

        // @ts-ignore
        if (window.VdoPlayer) {
            attachPlayer();
            return () => playerRef.current?.video?.removeEventListener("ended", handleEnded);
        }

        const script = document.createElement("script");
        script.src = "https://player.vdocipher.com/v2/api.js";
        script.onload = attachPlayer;
        document.body.appendChild(script);

        return () => playerRef.current?.video?.removeEventListener("ended", handleEnded);
    }, [])

    const isWatched = () => {
        const playerVideo = playerRef.current?.video;
        if (!playerVideo?.duration) {
            return false;
        }
        return Math.floor(playerVideo.currentTime) >= Math.floor(playerVideo.duration) - 3;
    };

    const handleFinish = () => {
        if (video.settings.view_all_to_complete && !isWatched()) {
            confirm({
                title: intl.formatMessage({id: 'general.attention'}),
                content: intl.formatMessage({id: 'student.video_warning'}),
                icon: <ExclamationCircleOutlined/>,
                okText: intl.formatMessage({id: 'general.yes'}),
                cancelText: intl.formatMessage({id: 'general.cancel'}),
                onOk() {
                    endVideoSession(false)
                }
            });
        } else {
            endVideoSession()
        }
    }

    return (
        <>
            <div className={'video-player-container'}>
                <iframe
                    style={{
                        height: "100%",
                        width: "100%"
                    }}
                    ref={iframeRef}
                    src={video.videoId}
                    allowFullScreen allow="encrypted-media"></iframe>
            </div>
            <div className='buttons-container'>
                <div></div>
                <Button loading={endLoading} onClick={() => handleFinish()}>
                    <FormattedMessage id='courses.finish'/>
                </Button>
            </div>
        </>
    );
};

export default VdocipherComponent;
